import { useMemo } from 'react';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { DialogId } from '../../ui/type.tsx';

// provides a stable handleClose function for analytics in the storage hard limits modal entrypoint
export const useStorageHardLimitsModalOnClose = (dialogId: DialogId) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(
		() => ({
			handleClose() {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'closed',
						actionSubject: 'modal',
					}),
					'storageHardLimitsModal',
					{ dialogId },
				);
			},
		}),
		[createAnalyticsEvent, dialogId],
	);
};
